import { State } from "./state";
import { storeInit } from "../../../Store";

const batt: State.Battery = {
  v: 0,
  vLoad: 0,
  i: 0,
  cur_zero: 0,
  chgGauge: 0,
  direct: false,
  Cap: 0,
  Lvl: 0,
  Present: false,
  iHigh: 0,
  chg_iHigh: 0,
  iLow: 0,
  chg_iLow: 0,
  vHigh: 0,
  vLow: 0,
  InstDate: "",
  ServDate: "",
  battStatus: ""
};

export const initial: State.Props = storeInit([{ ...batt }, { ...batt }]);

export default initial;
